import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import Layout from './src/components/layout'
import GoogleCaptcha from './src/templates/GoogleCaptcha'

const GA_MEASUREMENT_ID = process.env.GATSBY_GA_MEASUREMENT_ID
const RECAPTCHA_ROUTE_PREFIXES = ['/contact-engineer/', '/contact/', '/contact-company/', '/project-list/', '/lp/']

export const onRouteUpdate = ({ location }) => {
  if (!GA_MEASUREMENT_ID) return
  if (typeof window === 'undefined') return

  const pagePath = location?.pathname || window.location.pathname

  window.dataLayer = window.dataLayer || []
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments)
    }
  }

  window.gtag('config', GA_MEASUREMENT_ID, { page_path: pagePath })
}

export const wrapPageElement = ({ element, props }) => {
  const pathname = props?.location?.pathname || ''
  const shouldWrapWithRecaptcha = RECAPTCHA_ROUTE_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix),
  )
  const content = shouldWrapWithRecaptcha ? (
    <GoogleCaptcha>{element}</GoogleCaptcha>
  ) : (
    element
  )

  return <Layout {...props}>{content}</Layout>
}

export const wrapRootElement = ({ element }) => {
  return <HelmetProvider>{element}</HelmetProvider>
}
